import { useGlobalData } from "@/contexts/GlobalData";
import Image from "next/image";
import React from "react";
import DynamicFontSize from "../DynamicFontSize";
import styles from "./index.module.css";
import { cn } from "@/lib/utils";
import DynamicSizeIcon from "../DynamicSizeIcon";
import PrimaryButton from "../PrimaryButton";
function ComingSoonContent(props: {
  prefix?: string;
  onClickButton?: (data?: any) => any;
}) {
  const prefix = props.prefix ?? "navbar_";
  const {
    translate,
    getIcon
  } = useGlobalData();
  return <>
            <div style={{
      backgroundImage: `url(${getIcon("coming_soon_bg")})`
    }} className={cn("flex flex-col gap-4 w-full justify-center items-center bg-cover bg-center bg-no-repeat rounded-2xl pt-6 px-3")}>
                <DynamicFontSize fontSize={24} className="text-secondary font-secondary font-semibold" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                    {translate(prefix + "title")}
                </DynamicFontSize>
                <div className="flex flex-col text-white">
                    <DynamicFontSize fontSize={16} className="leading-[140%] font-medium font-secondary text-center" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                        {translate(prefix + "Sub title 1")}
                    </DynamicFontSize>
                    <DynamicFontSize fontSize={16} className="leading-[140%] font-medium font-secondary text-center" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                        {translate(prefix + "Sub title 2")}
                    </DynamicFontSize>
                    <DynamicFontSize fontSize={12} className="font-light mt-2 italic leading-[140%]" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                        {translate(prefix + "description")}
                    </DynamicFontSize>
                </div>
                <DynamicSizeIcon icon={getIcon(prefix + "coming_soon_icon")} width={130} height={171.279} data-sentry-element="DynamicSizeIcon" data-sentry-source-file="index.tsx" />
            </div>
            {!!props.onClickButton && <PrimaryButton className="w-full mt-4" onClick={props.onClickButton}>
                    {translate(prefix + "button_text")}
                </PrimaryButton>}
        </>;
}
export default ComingSoonContent;